/* tslint:disable */
/* eslint-disable */
/**
 * K1 OpenAPI
 * API fuer die Nutzung der K1 REST-Schnittstelle
 *
 * The version of the OpenAPI document: 1.156.0
 * Contact: diplan-backend@init.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { CodeVerfahrensschritt } from '../models';
// @ts-ignore
import { CodeVerfahrensunterlagetyp } from '../models';
// @ts-ignore
import { CodeVormerkung } from '../models';
// @ts-ignore
import { ErrorRest } from '../models';
// @ts-ignore
import { PageDokumentRest } from '../models';
// @ts-ignore
import { VertragsErgaenzungsdokumentEditRest } from '../models';
// @ts-ignore
import { VertragsErgaenzungsdokumentNeuRest } from '../models';
// @ts-ignore
import { VertragsErgaenzungsdokumentRest } from '../models';
// @ts-ignore
import { VertragsdokumentEditRest } from '../models';
// @ts-ignore
import { VertragsdokumentNeuRest } from '../models';
// @ts-ignore
import { VertragsdokumentRest } from '../models';
/**
 * VertragsdokumentResourceApi - axios parameter creator
 * @export
 */
export const VertragsdokumentResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein neues Vertragsdokument für ein Verfahren erstellt werden.<br> Neben den Metadaten des Vertragsdokuments muss auch der Inhalt übergeben werden.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
         * @summary Endpunkt der für ein Verfahren ein Vertragsdokument erstellt.
         * @param {VertragsdokumentNeuRest} vertrag 
         * @param {File} file Inhalt des Vertragsdokuments
         * @param {string} planID PlanID vom Verfahren
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<CreateVertragsdokumentSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVertragsdokument: async (vertrag: VertragsdokumentNeuRest, file: File, planID: string, page?: number, size?: number, sort?: Array<CreateVertragsdokumentSort>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vertrag' is not null or undefined
            assertParamExists('createVertragsdokument', 'vertrag', vertrag)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createVertragsdokument', 'file', file)
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('createVertragsdokument', 'planID', planID)
            const localVarPath = `/verfahren/{planID}/vertragsdokument`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


            if (vertrag !== undefined) { 
                localVarFormParams.append('vertrag', new Blob([JSON.stringify(vertrag)], { type: "application/json", }));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann für ein bestehendes Vertragsdokument ein neues Ergänzungsdokument erstellt werden.<br> Neben den Metadaten des Ergänzungsdokuments muss auch der Inhalt übergeben werden.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
         * @summary Endpunkt der für ein Vertragsdokument ein neues Ergänzungsdokument erstellt.
         * @param {VertragsErgaenzungsdokumentNeuRest} vertrag 
         * @param {File} file Inhalt des Ergänzungsdokuments
         * @param {string} planID PlanID vom Verfahren
         * @param {string} fileID FileID des Vertragsdokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVertragsdokumentErgaenzung: async (vertrag: VertragsErgaenzungsdokumentNeuRest, file: File, planID: string, fileID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vertrag' is not null or undefined
            assertParamExists('createVertragsdokumentErgaenzung', 'vertrag', vertrag)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createVertragsdokumentErgaenzung', 'file', file)
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('createVertragsdokumentErgaenzung', 'planID', planID)
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('createVertragsdokumentErgaenzung', 'fileID', fileID)
            const localVarPath = `/verfahren/{planID}/vertragsdokument/{fileID}/ergaenzung`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (vertrag !== undefined) { 
                localVarFormParams.append('vertrag', new Blob([JSON.stringify(vertrag)], { type: "application/json", }));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden für ein bestehendes Vertragsdokument die Ergänzungsdokumente ausgeliefert.</p><p><b>Benötigte Rechte:</b> VERTRAG_READ or EIGENE_VERTRAG_READ or ADMIN</p>
         * @summary Endpunkt der für ein Vertragsdokument die Ergänzungsdokumente ausliefert.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} vertragsdokumentFileID FileID des Vertragsdokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVertragsdokumentErgaenzungen: async (planID: string, vertragsdokumentFileID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('getVertragsdokumentErgaenzungen', 'planID', planID)
            // verify required parameter 'vertragsdokumentFileID' is not null or undefined
            assertParamExists('getVertragsdokumentErgaenzungen', 'vertragsdokumentFileID', vertragsdokumentFileID)
            const localVarPath = `/verfahren/{planID}/vertragsdokument/{vertragsdokumentFileID}/ergaenzung`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"vertragsdokumentFileID"}}`, encodeURIComponent(String(vertragsdokumentFileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Verträge eines Verfahrens ausgeliefert.<br> Die Ergebnismenge kann optional mit Suchparametern gefiltert werden.<br> Gelöschte Vertragsdokumente werden bei keiner Angabe von Suchparametern gefiltert.<br><br> Unterstützte Sortierfelder (per \"sort\" Query-Parameter):<br>   filename – Sortierung nach dem Dateinamen des Dokuments<br>   bearbeiter – Sortierung nach dem Bearbeiter<br>   verfahrensunterlagetyp – Sortierung nach dem Typ<br>   lastModified – Sortierung nach dem Änderungsdatum<br>   status – Sortierung nach dem aktuellsten Dokumentstatus<br>   vormerkung – Sortierung nach Vormerkung<br>   durchgang – Sortierung nach dem Durchgangszähler des Verfahrensteilschritts<br>   version – Sortierung nach der Versionsnummer<br>   dateigroesse – Sortierung nach der Dateigröße<br>   vertragsart – Sortierung nach Vertragsart<br>   unterzeichner – Sortierung nach dem Unterzeichner<br>   unterzeichnung – Sortierung nach dem Unterzeichnungsdatum<br>   inkrafttreten – Sortierung nach dem Datum des Inkrafttretens</p><p><b>Benötigte Rechte:</b> VERTRAG_READ or EIGENE_VERTRAG_READ or ADMIN</p>
         * @summary Endpunkt der alle Vertragsdokumente eines Verfahrens ausliefert.
         * @param {string} planID planID vom Verfahren
         * @param {string} [suchBegriff] Suchbegriff
         * @param {Array<string>} [dateiNamen] Dateiname
         * @param {Array<string>} [bearbeiter] Bearbeiter
         * @param {Array<string>} [datum] Bearbeitungsdatum
         * @param {Array<string>} [codeDokumentstatus] Dokumentstatus
         * @param {Array<string>} [versionen] Version
         * @param {Array<CodeVormerkung>} [codeVormerkung] Vormerkung
         * @param {Array<CodeVerfahrensunterlagetyp>} [codeVerfahrensunterlagetyp] Verfahrensunterlagetyp
         * @param {Array<string>} [fileID] fileIDs von Dokumenten zum filtern
         * @param {Array<GetVertragsdokumenteKlassifizierung>} [klassifizierung] Liste der Klassifizerungen
         * @param {Array<CodeVerfahrensschritt>} [codeVerfahrensschritt] Verfahrensschritt
         * @param {boolean} [papierkorb] Gibt an, ob Dokumente ohne Dokumentstatus ausgeschossen werden müssen
         * @param {boolean} [mitErgaenzungen] Gibt an, ob VertragsErgaenzungsdokument ausgegeben werden müssen
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<GetVertragsdokumenteSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVertragsdokumente: async (planID: string, suchBegriff?: string, dateiNamen?: Array<string>, bearbeiter?: Array<string>, datum?: Array<string>, codeDokumentstatus?: Array<string>, versionen?: Array<string>, codeVormerkung?: Array<CodeVormerkung>, codeVerfahrensunterlagetyp?: Array<CodeVerfahrensunterlagetyp>, fileID?: Array<string>, klassifizierung?: Array<GetVertragsdokumenteKlassifizierung>, codeVerfahrensschritt?: Array<CodeVerfahrensschritt>, papierkorb?: boolean, mitErgaenzungen?: boolean, page?: number, size?: number, sort?: Array<GetVertragsdokumenteSort>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('getVertragsdokumente', 'planID', planID)
            const localVarPath = `/verfahren/{planID}/vertragsdokument`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (suchBegriff !== undefined) {
                localVarQueryParameter['suchBegriff'] = suchBegriff;
            }

            if (dateiNamen) {
                localVarQueryParameter['dateiNamen'] = dateiNamen;
            }

            if (bearbeiter) {
                localVarQueryParameter['bearbeiter'] = bearbeiter;
            }

            if (datum) {
                localVarQueryParameter['datum'] = datum;
            }

            if (codeDokumentstatus) {
                localVarQueryParameter['codeDokumentstatus'] = codeDokumentstatus;
            }

            if (versionen) {
                localVarQueryParameter['versionen'] = versionen;
            }

            if (codeVormerkung) {
                localVarQueryParameter['codeVormerkung'] = codeVormerkung;
            }

            if (codeVerfahrensunterlagetyp) {
                localVarQueryParameter['codeVerfahrensunterlagetyp'] = codeVerfahrensunterlagetyp;
            }

            if (fileID) {
                localVarQueryParameter['fileID'] = fileID;
            }

            if (klassifizierung) {
                localVarQueryParameter['klassifizierung'] = klassifizierung;
            }

            if (codeVerfahrensschritt) {
                localVarQueryParameter['codeVerfahrensschritt'] = codeVerfahrensschritt;
            }

            if (papierkorb !== undefined) {
                localVarQueryParameter['papierkorb'] = papierkorb;
            }

            if (mitErgaenzungen !== undefined) {
                localVarQueryParameter['mitErgaenzungen'] = mitErgaenzungen;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehendes Vertragsdokument eines Verfahrens aktualisiert werden.<br> Neben den Metadaten des Vertragsdokuments wird auch der Inhalt aktualisiert.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
         * @summary Endpunkt der für ein Verfahren ein Vertragsdokument aktualisiert.
         * @param {VertragsdokumentEditRest} vertrag 
         * @param {string} planID PlanID vom Verfahren
         * @param {string} fileID FileID des Vertragsdokument
         * @param {File} [file] Inhalt des Vertragsdokuments as aktualisiert werden soll
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVertragsdokument: async (vertrag: VertragsdokumentEditRest, planID: string, fileID: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vertrag' is not null or undefined
            assertParamExists('updateVertragsdokument', 'vertrag', vertrag)
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('updateVertragsdokument', 'planID', planID)
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('updateVertragsdokument', 'fileID', fileID)
            const localVarPath = `/verfahren/{planID}/vertragsdokument/{fileID}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (vertrag !== undefined) { 
                localVarFormParams.append('vertrag', new Blob([JSON.stringify(vertrag)], { type: "application/json", }));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehendes Ergänzungsdokument eines Vertrages aktualisiert werden.<br> Neben den Metadaten des Ergänzungsdokuments kann auch der Inhalt aktualisiert werden.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Aktualisieren eines Ergänzungsdokuments eines Vertrages.
         * @param {VertragsErgaenzungsdokumentEditRest} vertrag 
         * @param {string} planID PlanID vom Verfahren
         * @param {string} vertragsdokumentFileID FileID des Vertragsdokument
         * @param {string} fileID FileID des Ergänzungsdokument
         * @param {File} [file] Inhalt des Ergänzungsdokuments die aktualisiert werden sollen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVertragsdokumentErgaenzung: async (vertrag: VertragsErgaenzungsdokumentEditRest, planID: string, vertragsdokumentFileID: string, fileID: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vertrag' is not null or undefined
            assertParamExists('updateVertragsdokumentErgaenzung', 'vertrag', vertrag)
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('updateVertragsdokumentErgaenzung', 'planID', planID)
            // verify required parameter 'vertragsdokumentFileID' is not null or undefined
            assertParamExists('updateVertragsdokumentErgaenzung', 'vertragsdokumentFileID', vertragsdokumentFileID)
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('updateVertragsdokumentErgaenzung', 'fileID', fileID)
            const localVarPath = `/verfahren/{planID}/vertragsdokument/{vertragsdokumentFileID}/ergaenzung/{fileID}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"vertragsdokumentFileID"}}`, encodeURIComponent(String(vertragsdokumentFileID)))
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (vertrag !== undefined) { 
                localVarFormParams.append('vertrag', new Blob([JSON.stringify(vertrag)], { type: "application/json", }));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VertragsdokumentResourceApi - functional programming interface
 * @export
 */
export const VertragsdokumentResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VertragsdokumentResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein neues Vertragsdokument für ein Verfahren erstellt werden.<br> Neben den Metadaten des Vertragsdokuments muss auch der Inhalt übergeben werden.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
         * @summary Endpunkt der für ein Verfahren ein Vertragsdokument erstellt.
         * @param {VertragsdokumentNeuRest} vertrag 
         * @param {File} file Inhalt des Vertragsdokuments
         * @param {string} planID PlanID vom Verfahren
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<CreateVertragsdokumentSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVertragsdokument(vertrag: VertragsdokumentNeuRest, file: File, planID: string, page?: number, size?: number, sort?: Array<CreateVertragsdokumentSort>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VertragsdokumentRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVertragsdokument(vertrag, file, planID, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VertragsdokumentResourceApi.createVertragsdokument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann für ein bestehendes Vertragsdokument ein neues Ergänzungsdokument erstellt werden.<br> Neben den Metadaten des Ergänzungsdokuments muss auch der Inhalt übergeben werden.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
         * @summary Endpunkt der für ein Vertragsdokument ein neues Ergänzungsdokument erstellt.
         * @param {VertragsErgaenzungsdokumentNeuRest} vertrag 
         * @param {File} file Inhalt des Ergänzungsdokuments
         * @param {string} planID PlanID vom Verfahren
         * @param {string} fileID FileID des Vertragsdokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVertragsdokumentErgaenzung(vertrag: VertragsErgaenzungsdokumentNeuRest, file: File, planID: string, fileID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VertragsErgaenzungsdokumentRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVertragsdokumentErgaenzung(vertrag, file, planID, fileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VertragsdokumentResourceApi.createVertragsdokumentErgaenzung']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden für ein bestehendes Vertragsdokument die Ergänzungsdokumente ausgeliefert.</p><p><b>Benötigte Rechte:</b> VERTRAG_READ or EIGENE_VERTRAG_READ or ADMIN</p>
         * @summary Endpunkt der für ein Vertragsdokument die Ergänzungsdokumente ausliefert.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} vertragsdokumentFileID FileID des Vertragsdokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVertragsdokumentErgaenzungen(planID: string, vertragsdokumentFileID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VertragsErgaenzungsdokumentRest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVertragsdokumentErgaenzungen(planID, vertragsdokumentFileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VertragsdokumentResourceApi.getVertragsdokumentErgaenzungen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Verträge eines Verfahrens ausgeliefert.<br> Die Ergebnismenge kann optional mit Suchparametern gefiltert werden.<br> Gelöschte Vertragsdokumente werden bei keiner Angabe von Suchparametern gefiltert.<br><br> Unterstützte Sortierfelder (per \"sort\" Query-Parameter):<br>   filename – Sortierung nach dem Dateinamen des Dokuments<br>   bearbeiter – Sortierung nach dem Bearbeiter<br>   verfahrensunterlagetyp – Sortierung nach dem Typ<br>   lastModified – Sortierung nach dem Änderungsdatum<br>   status – Sortierung nach dem aktuellsten Dokumentstatus<br>   vormerkung – Sortierung nach Vormerkung<br>   durchgang – Sortierung nach dem Durchgangszähler des Verfahrensteilschritts<br>   version – Sortierung nach der Versionsnummer<br>   dateigroesse – Sortierung nach der Dateigröße<br>   vertragsart – Sortierung nach Vertragsart<br>   unterzeichner – Sortierung nach dem Unterzeichner<br>   unterzeichnung – Sortierung nach dem Unterzeichnungsdatum<br>   inkrafttreten – Sortierung nach dem Datum des Inkrafttretens</p><p><b>Benötigte Rechte:</b> VERTRAG_READ or EIGENE_VERTRAG_READ or ADMIN</p>
         * @summary Endpunkt der alle Vertragsdokumente eines Verfahrens ausliefert.
         * @param {string} planID planID vom Verfahren
         * @param {string} [suchBegriff] Suchbegriff
         * @param {Array<string>} [dateiNamen] Dateiname
         * @param {Array<string>} [bearbeiter] Bearbeiter
         * @param {Array<string>} [datum] Bearbeitungsdatum
         * @param {Array<string>} [codeDokumentstatus] Dokumentstatus
         * @param {Array<string>} [versionen] Version
         * @param {Array<CodeVormerkung>} [codeVormerkung] Vormerkung
         * @param {Array<CodeVerfahrensunterlagetyp>} [codeVerfahrensunterlagetyp] Verfahrensunterlagetyp
         * @param {Array<string>} [fileID] fileIDs von Dokumenten zum filtern
         * @param {Array<GetVertragsdokumenteKlassifizierung>} [klassifizierung] Liste der Klassifizerungen
         * @param {Array<CodeVerfahrensschritt>} [codeVerfahrensschritt] Verfahrensschritt
         * @param {boolean} [papierkorb] Gibt an, ob Dokumente ohne Dokumentstatus ausgeschossen werden müssen
         * @param {boolean} [mitErgaenzungen] Gibt an, ob VertragsErgaenzungsdokument ausgegeben werden müssen
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<GetVertragsdokumenteSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVertragsdokumente(planID: string, suchBegriff?: string, dateiNamen?: Array<string>, bearbeiter?: Array<string>, datum?: Array<string>, codeDokumentstatus?: Array<string>, versionen?: Array<string>, codeVormerkung?: Array<CodeVormerkung>, codeVerfahrensunterlagetyp?: Array<CodeVerfahrensunterlagetyp>, fileID?: Array<string>, klassifizierung?: Array<GetVertragsdokumenteKlassifizierung>, codeVerfahrensschritt?: Array<CodeVerfahrensschritt>, papierkorb?: boolean, mitErgaenzungen?: boolean, page?: number, size?: number, sort?: Array<GetVertragsdokumenteSort>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDokumentRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVertragsdokumente(planID, suchBegriff, dateiNamen, bearbeiter, datum, codeDokumentstatus, versionen, codeVormerkung, codeVerfahrensunterlagetyp, fileID, klassifizierung, codeVerfahrensschritt, papierkorb, mitErgaenzungen, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VertragsdokumentResourceApi.getVertragsdokumente']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehendes Vertragsdokument eines Verfahrens aktualisiert werden.<br> Neben den Metadaten des Vertragsdokuments wird auch der Inhalt aktualisiert.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
         * @summary Endpunkt der für ein Verfahren ein Vertragsdokument aktualisiert.
         * @param {VertragsdokumentEditRest} vertrag 
         * @param {string} planID PlanID vom Verfahren
         * @param {string} fileID FileID des Vertragsdokument
         * @param {File} [file] Inhalt des Vertragsdokuments as aktualisiert werden soll
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVertragsdokument(vertrag: VertragsdokumentEditRest, planID: string, fileID: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VertragsdokumentRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVertragsdokument(vertrag, planID, fileID, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VertragsdokumentResourceApi.updateVertragsdokument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehendes Ergänzungsdokument eines Vertrages aktualisiert werden.<br> Neben den Metadaten des Ergänzungsdokuments kann auch der Inhalt aktualisiert werden.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Aktualisieren eines Ergänzungsdokuments eines Vertrages.
         * @param {VertragsErgaenzungsdokumentEditRest} vertrag 
         * @param {string} planID PlanID vom Verfahren
         * @param {string} vertragsdokumentFileID FileID des Vertragsdokument
         * @param {string} fileID FileID des Ergänzungsdokument
         * @param {File} [file] Inhalt des Ergänzungsdokuments die aktualisiert werden sollen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVertragsdokumentErgaenzung(vertrag: VertragsErgaenzungsdokumentEditRest, planID: string, vertragsdokumentFileID: string, fileID: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VertragsErgaenzungsdokumentRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVertragsdokumentErgaenzung(vertrag, planID, vertragsdokumentFileID, fileID, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VertragsdokumentResourceApi.updateVertragsdokumentErgaenzung']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VertragsdokumentResourceApi - factory interface
 * @export
 */
export const VertragsdokumentResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VertragsdokumentResourceApiFp(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein neues Vertragsdokument für ein Verfahren erstellt werden.<br> Neben den Metadaten des Vertragsdokuments muss auch der Inhalt übergeben werden.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
         * @summary Endpunkt der für ein Verfahren ein Vertragsdokument erstellt.
         * @param {VertragsdokumentNeuRest} vertrag 
         * @param {File} file Inhalt des Vertragsdokuments
         * @param {string} planID PlanID vom Verfahren
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<CreateVertragsdokumentSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVertragsdokument(vertrag: VertragsdokumentNeuRest, file: File, planID: string, page?: number, size?: number, sort?: Array<CreateVertragsdokumentSort>, options?: any): AxiosPromise<VertragsdokumentRest> {
            return localVarFp.createVertragsdokument(vertrag, file, planID, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann für ein bestehendes Vertragsdokument ein neues Ergänzungsdokument erstellt werden.<br> Neben den Metadaten des Ergänzungsdokuments muss auch der Inhalt übergeben werden.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
         * @summary Endpunkt der für ein Vertragsdokument ein neues Ergänzungsdokument erstellt.
         * @param {VertragsErgaenzungsdokumentNeuRest} vertrag 
         * @param {File} file Inhalt des Ergänzungsdokuments
         * @param {string} planID PlanID vom Verfahren
         * @param {string} fileID FileID des Vertragsdokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVertragsdokumentErgaenzung(vertrag: VertragsErgaenzungsdokumentNeuRest, file: File, planID: string, fileID: string, options?: any): AxiosPromise<VertragsErgaenzungsdokumentRest> {
            return localVarFp.createVertragsdokumentErgaenzung(vertrag, file, planID, fileID, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden für ein bestehendes Vertragsdokument die Ergänzungsdokumente ausgeliefert.</p><p><b>Benötigte Rechte:</b> VERTRAG_READ or EIGENE_VERTRAG_READ or ADMIN</p>
         * @summary Endpunkt der für ein Vertragsdokument die Ergänzungsdokumente ausliefert.
         * @param {string} planID PlanID vom Verfahren
         * @param {string} vertragsdokumentFileID FileID des Vertragsdokument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVertragsdokumentErgaenzungen(planID: string, vertragsdokumentFileID: string, options?: any): AxiosPromise<Array<VertragsErgaenzungsdokumentRest>> {
            return localVarFp.getVertragsdokumentErgaenzungen(planID, vertragsdokumentFileID, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Verträge eines Verfahrens ausgeliefert.<br> Die Ergebnismenge kann optional mit Suchparametern gefiltert werden.<br> Gelöschte Vertragsdokumente werden bei keiner Angabe von Suchparametern gefiltert.<br><br> Unterstützte Sortierfelder (per \"sort\" Query-Parameter):<br>   filename – Sortierung nach dem Dateinamen des Dokuments<br>   bearbeiter – Sortierung nach dem Bearbeiter<br>   verfahrensunterlagetyp – Sortierung nach dem Typ<br>   lastModified – Sortierung nach dem Änderungsdatum<br>   status – Sortierung nach dem aktuellsten Dokumentstatus<br>   vormerkung – Sortierung nach Vormerkung<br>   durchgang – Sortierung nach dem Durchgangszähler des Verfahrensteilschritts<br>   version – Sortierung nach der Versionsnummer<br>   dateigroesse – Sortierung nach der Dateigröße<br>   vertragsart – Sortierung nach Vertragsart<br>   unterzeichner – Sortierung nach dem Unterzeichner<br>   unterzeichnung – Sortierung nach dem Unterzeichnungsdatum<br>   inkrafttreten – Sortierung nach dem Datum des Inkrafttretens</p><p><b>Benötigte Rechte:</b> VERTRAG_READ or EIGENE_VERTRAG_READ or ADMIN</p>
         * @summary Endpunkt der alle Vertragsdokumente eines Verfahrens ausliefert.
         * @param {string} planID planID vom Verfahren
         * @param {string} [suchBegriff] Suchbegriff
         * @param {Array<string>} [dateiNamen] Dateiname
         * @param {Array<string>} [bearbeiter] Bearbeiter
         * @param {Array<string>} [datum] Bearbeitungsdatum
         * @param {Array<string>} [codeDokumentstatus] Dokumentstatus
         * @param {Array<string>} [versionen] Version
         * @param {Array<CodeVormerkung>} [codeVormerkung] Vormerkung
         * @param {Array<CodeVerfahrensunterlagetyp>} [codeVerfahrensunterlagetyp] Verfahrensunterlagetyp
         * @param {Array<string>} [fileID] fileIDs von Dokumenten zum filtern
         * @param {Array<GetVertragsdokumenteKlassifizierung>} [klassifizierung] Liste der Klassifizerungen
         * @param {Array<CodeVerfahrensschritt>} [codeVerfahrensschritt] Verfahrensschritt
         * @param {boolean} [papierkorb] Gibt an, ob Dokumente ohne Dokumentstatus ausgeschossen werden müssen
         * @param {boolean} [mitErgaenzungen] Gibt an, ob VertragsErgaenzungsdokument ausgegeben werden müssen
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<GetVertragsdokumenteSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVertragsdokumente(planID: string, suchBegriff?: string, dateiNamen?: Array<string>, bearbeiter?: Array<string>, datum?: Array<string>, codeDokumentstatus?: Array<string>, versionen?: Array<string>, codeVormerkung?: Array<CodeVormerkung>, codeVerfahrensunterlagetyp?: Array<CodeVerfahrensunterlagetyp>, fileID?: Array<string>, klassifizierung?: Array<GetVertragsdokumenteKlassifizierung>, codeVerfahrensschritt?: Array<CodeVerfahrensschritt>, papierkorb?: boolean, mitErgaenzungen?: boolean, page?: number, size?: number, sort?: Array<GetVertragsdokumenteSort>, options?: any): AxiosPromise<PageDokumentRest> {
            return localVarFp.getVertragsdokumente(planID, suchBegriff, dateiNamen, bearbeiter, datum, codeDokumentstatus, versionen, codeVormerkung, codeVerfahrensunterlagetyp, fileID, klassifizierung, codeVerfahrensschritt, papierkorb, mitErgaenzungen, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehendes Vertragsdokument eines Verfahrens aktualisiert werden.<br> Neben den Metadaten des Vertragsdokuments wird auch der Inhalt aktualisiert.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
         * @summary Endpunkt der für ein Verfahren ein Vertragsdokument aktualisiert.
         * @param {VertragsdokumentEditRest} vertrag 
         * @param {string} planID PlanID vom Verfahren
         * @param {string} fileID FileID des Vertragsdokument
         * @param {File} [file] Inhalt des Vertragsdokuments as aktualisiert werden soll
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVertragsdokument(vertrag: VertragsdokumentEditRest, planID: string, fileID: string, file?: File, options?: any): AxiosPromise<VertragsdokumentRest> {
            return localVarFp.updateVertragsdokument(vertrag, planID, fileID, file, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehendes Ergänzungsdokument eines Vertrages aktualisiert werden.<br> Neben den Metadaten des Ergänzungsdokuments kann auch der Inhalt aktualisiert werden.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Aktualisieren eines Ergänzungsdokuments eines Vertrages.
         * @param {VertragsErgaenzungsdokumentEditRest} vertrag 
         * @param {string} planID PlanID vom Verfahren
         * @param {string} vertragsdokumentFileID FileID des Vertragsdokument
         * @param {string} fileID FileID des Ergänzungsdokument
         * @param {File} [file] Inhalt des Ergänzungsdokuments die aktualisiert werden sollen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVertragsdokumentErgaenzung(vertrag: VertragsErgaenzungsdokumentEditRest, planID: string, vertragsdokumentFileID: string, fileID: string, file?: File, options?: any): AxiosPromise<VertragsErgaenzungsdokumentRest> {
            return localVarFp.updateVertragsdokumentErgaenzung(vertrag, planID, vertragsdokumentFileID, fileID, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VertragsdokumentResourceApi - object-oriented interface
 * @export
 * @class VertragsdokumentResourceApi
 * @extends {BaseAPI}
 */
export class VertragsdokumentResourceApi extends BaseAPI {
    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein neues Vertragsdokument für ein Verfahren erstellt werden.<br> Neben den Metadaten des Vertragsdokuments muss auch der Inhalt übergeben werden.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
     * @summary Endpunkt der für ein Verfahren ein Vertragsdokument erstellt.
     * @param {VertragsdokumentNeuRest} vertrag 
     * @param {File} file Inhalt des Vertragsdokuments
     * @param {string} planID PlanID vom Verfahren
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<CreateVertragsdokumentSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VertragsdokumentResourceApi
     */
    public createVertragsdokument(vertrag: VertragsdokumentNeuRest, file: File, planID: string, page?: number, size?: number, sort?: Array<CreateVertragsdokumentSort>, options?: RawAxiosRequestConfig) {
        return VertragsdokumentResourceApiFp(this.configuration).createVertragsdokument(vertrag, file, planID, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann für ein bestehendes Vertragsdokument ein neues Ergänzungsdokument erstellt werden.<br> Neben den Metadaten des Ergänzungsdokuments muss auch der Inhalt übergeben werden.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
     * @summary Endpunkt der für ein Vertragsdokument ein neues Ergänzungsdokument erstellt.
     * @param {VertragsErgaenzungsdokumentNeuRest} vertrag 
     * @param {File} file Inhalt des Ergänzungsdokuments
     * @param {string} planID PlanID vom Verfahren
     * @param {string} fileID FileID des Vertragsdokument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VertragsdokumentResourceApi
     */
    public createVertragsdokumentErgaenzung(vertrag: VertragsErgaenzungsdokumentNeuRest, file: File, planID: string, fileID: string, options?: RawAxiosRequestConfig) {
        return VertragsdokumentResourceApiFp(this.configuration).createVertragsdokumentErgaenzung(vertrag, file, planID, fileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden für ein bestehendes Vertragsdokument die Ergänzungsdokumente ausgeliefert.</p><p><b>Benötigte Rechte:</b> VERTRAG_READ or EIGENE_VERTRAG_READ or ADMIN</p>
     * @summary Endpunkt der für ein Vertragsdokument die Ergänzungsdokumente ausliefert.
     * @param {string} planID PlanID vom Verfahren
     * @param {string} vertragsdokumentFileID FileID des Vertragsdokument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VertragsdokumentResourceApi
     */
    public getVertragsdokumentErgaenzungen(planID: string, vertragsdokumentFileID: string, options?: RawAxiosRequestConfig) {
        return VertragsdokumentResourceApiFp(this.configuration).getVertragsdokumentErgaenzungen(planID, vertragsdokumentFileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Verträge eines Verfahrens ausgeliefert.<br> Die Ergebnismenge kann optional mit Suchparametern gefiltert werden.<br> Gelöschte Vertragsdokumente werden bei keiner Angabe von Suchparametern gefiltert.<br><br> Unterstützte Sortierfelder (per \"sort\" Query-Parameter):<br>   filename – Sortierung nach dem Dateinamen des Dokuments<br>   bearbeiter – Sortierung nach dem Bearbeiter<br>   verfahrensunterlagetyp – Sortierung nach dem Typ<br>   lastModified – Sortierung nach dem Änderungsdatum<br>   status – Sortierung nach dem aktuellsten Dokumentstatus<br>   vormerkung – Sortierung nach Vormerkung<br>   durchgang – Sortierung nach dem Durchgangszähler des Verfahrensteilschritts<br>   version – Sortierung nach der Versionsnummer<br>   dateigroesse – Sortierung nach der Dateigröße<br>   vertragsart – Sortierung nach Vertragsart<br>   unterzeichner – Sortierung nach dem Unterzeichner<br>   unterzeichnung – Sortierung nach dem Unterzeichnungsdatum<br>   inkrafttreten – Sortierung nach dem Datum des Inkrafttretens</p><p><b>Benötigte Rechte:</b> VERTRAG_READ or EIGENE_VERTRAG_READ or ADMIN</p>
     * @summary Endpunkt der alle Vertragsdokumente eines Verfahrens ausliefert.
     * @param {string} planID planID vom Verfahren
     * @param {string} [suchBegriff] Suchbegriff
     * @param {Array<string>} [dateiNamen] Dateiname
     * @param {Array<string>} [bearbeiter] Bearbeiter
     * @param {Array<string>} [datum] Bearbeitungsdatum
     * @param {Array<string>} [codeDokumentstatus] Dokumentstatus
     * @param {Array<string>} [versionen] Version
     * @param {Array<CodeVormerkung>} [codeVormerkung] Vormerkung
     * @param {Array<CodeVerfahrensunterlagetyp>} [codeVerfahrensunterlagetyp] Verfahrensunterlagetyp
     * @param {Array<string>} [fileID] fileIDs von Dokumenten zum filtern
     * @param {Array<GetVertragsdokumenteKlassifizierung>} [klassifizierung] Liste der Klassifizerungen
     * @param {Array<CodeVerfahrensschritt>} [codeVerfahrensschritt] Verfahrensschritt
     * @param {boolean} [papierkorb] Gibt an, ob Dokumente ohne Dokumentstatus ausgeschossen werden müssen
     * @param {boolean} [mitErgaenzungen] Gibt an, ob VertragsErgaenzungsdokument ausgegeben werden müssen
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<GetVertragsdokumenteSort>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VertragsdokumentResourceApi
     */
    public getVertragsdokumente(planID: string, suchBegriff?: string, dateiNamen?: Array<string>, bearbeiter?: Array<string>, datum?: Array<string>, codeDokumentstatus?: Array<string>, versionen?: Array<string>, codeVormerkung?: Array<CodeVormerkung>, codeVerfahrensunterlagetyp?: Array<CodeVerfahrensunterlagetyp>, fileID?: Array<string>, klassifizierung?: Array<GetVertragsdokumenteKlassifizierung>, codeVerfahrensschritt?: Array<CodeVerfahrensschritt>, papierkorb?: boolean, mitErgaenzungen?: boolean, page?: number, size?: number, sort?: Array<GetVertragsdokumenteSort>, options?: RawAxiosRequestConfig) {
        return VertragsdokumentResourceApiFp(this.configuration).getVertragsdokumente(planID, suchBegriff, dateiNamen, bearbeiter, datum, codeDokumentstatus, versionen, codeVormerkung, codeVerfahrensunterlagetyp, fileID, klassifizierung, codeVerfahrensschritt, papierkorb, mitErgaenzungen, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehendes Vertragsdokument eines Verfahrens aktualisiert werden.<br> Neben den Metadaten des Vertragsdokuments wird auch der Inhalt aktualisiert.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
     * @summary Endpunkt der für ein Verfahren ein Vertragsdokument aktualisiert.
     * @param {VertragsdokumentEditRest} vertrag 
     * @param {string} planID PlanID vom Verfahren
     * @param {string} fileID FileID des Vertragsdokument
     * @param {File} [file] Inhalt des Vertragsdokuments as aktualisiert werden soll
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VertragsdokumentResourceApi
     */
    public updateVertragsdokument(vertrag: VertragsdokumentEditRest, planID: string, fileID: string, file?: File, options?: RawAxiosRequestConfig) {
        return VertragsdokumentResourceApiFp(this.configuration).updateVertragsdokument(vertrag, planID, fileID, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt kann ein bestehendes Ergänzungsdokument eines Vertrages aktualisiert werden.<br> Neben den Metadaten des Ergänzungsdokuments kann auch der Inhalt aktualisiert werden.</p><p><b>Benötigte Rechte:</b> VERTRAG_WRITE or EIGENE_VERTRAG_WRITE or ADMIN</p>
     * @summary Endpunkt zum Aktualisieren eines Ergänzungsdokuments eines Vertrages.
     * @param {VertragsErgaenzungsdokumentEditRest} vertrag 
     * @param {string} planID PlanID vom Verfahren
     * @param {string} vertragsdokumentFileID FileID des Vertragsdokument
     * @param {string} fileID FileID des Ergänzungsdokument
     * @param {File} [file] Inhalt des Ergänzungsdokuments die aktualisiert werden sollen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VertragsdokumentResourceApi
     */
    public updateVertragsdokumentErgaenzung(vertrag: VertragsErgaenzungsdokumentEditRest, planID: string, vertragsdokumentFileID: string, fileID: string, file?: File, options?: RawAxiosRequestConfig) {
        return VertragsdokumentResourceApiFp(this.configuration).updateVertragsdokumentErgaenzung(vertrag, planID, vertragsdokumentFileID, fileID, file, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CreateVertragsdokumentSort = {
    filename: 'filename',
    filenameasc: 'filename,asc',
    filenamedesc: 'filename,desc',
    bearbeiter: 'bearbeiter',
    bearbeiterasc: 'bearbeiter,asc',
    bearbeiterdesc: 'bearbeiter,desc',
    verfahrensunterlagetyp: 'verfahrensunterlagetyp',
    verfahrensunterlagetypasc: 'verfahrensunterlagetyp,asc',
    verfahrensunterlagetypdesc: 'verfahrensunterlagetyp,desc',
    lastModified: 'lastModified',
    lastModifiedasc: 'lastModified,asc',
    lastModifieddesc: 'lastModified,desc',
    status: 'status',
    statusasc: 'status,asc',
    statusdesc: 'status,desc',
    vormerkung: 'vormerkung',
    vormerkungasc: 'vormerkung,asc',
    vormerkungdesc: 'vormerkung,desc',
    durchgang: 'durchgang',
    durchgangasc: 'durchgang,asc',
    durchgangdesc: 'durchgang,desc',
    version: 'version',
    versionasc: 'version,asc',
    versiondesc: 'version,desc',
    dateigroesse: 'dateigroesse',
    dateigroesseasc: 'dateigroesse,asc',
    dateigroessedesc: 'dateigroesse,desc',
    vertragsart: 'vertragsart',
    vertragsartasc: 'vertragsart,asc',
    vertragsartdesc: 'vertragsart,desc',
    unterzeichner: 'unterzeichner',
    unterzeichnerasc: 'unterzeichner,asc',
    unterzeichnerdesc: 'unterzeichner,desc',
    unterzeichnung: 'unterzeichnung',
    unterzeichnungasc: 'unterzeichnung,asc',
    unterzeichnungdesc: 'unterzeichnung,desc',
    inkrafttreten: 'inkrafttreten',
    inkrafttretenasc: 'inkrafttreten,asc',
    inkrafttretendesc: 'inkrafttreten,desc'
} as const;
export type CreateVertragsdokumentSort = typeof CreateVertragsdokumentSort[keyof typeof CreateVertragsdokumentSort];
/**
 * @export
 */
export const GetVertragsdokumenteKlassifizierung = {
    VERFAHREN: 'VERFAHREN',
    STELLUNGNAHME: 'STELLUNGNAHME'
} as const;
export type GetVertragsdokumenteKlassifizierung = typeof GetVertragsdokumenteKlassifizierung[keyof typeof GetVertragsdokumenteKlassifizierung];
/**
 * @export
 */
export const GetVertragsdokumenteSort = {
    filename: 'filename',
    filenameasc: 'filename,asc',
    filenamedesc: 'filename,desc',
    bearbeiter: 'bearbeiter',
    bearbeiterasc: 'bearbeiter,asc',
    bearbeiterdesc: 'bearbeiter,desc',
    verfahrensunterlagetyp: 'verfahrensunterlagetyp',
    verfahrensunterlagetypasc: 'verfahrensunterlagetyp,asc',
    verfahrensunterlagetypdesc: 'verfahrensunterlagetyp,desc',
    lastModified: 'lastModified',
    lastModifiedasc: 'lastModified,asc',
    lastModifieddesc: 'lastModified,desc',
    status: 'status',
    statusasc: 'status,asc',
    statusdesc: 'status,desc',
    vormerkung: 'vormerkung',
    vormerkungasc: 'vormerkung,asc',
    vormerkungdesc: 'vormerkung,desc',
    durchgang: 'durchgang',
    durchgangasc: 'durchgang,asc',
    durchgangdesc: 'durchgang,desc',
    version: 'version',
    versionasc: 'version,asc',
    versiondesc: 'version,desc',
    dateigroesse: 'dateigroesse',
    dateigroesseasc: 'dateigroesse,asc',
    dateigroessedesc: 'dateigroesse,desc',
    vertragsart: 'vertragsart',
    vertragsartasc: 'vertragsart,asc',
    vertragsartdesc: 'vertragsart,desc',
    unterzeichner: 'unterzeichner',
    unterzeichnerasc: 'unterzeichner,asc',
    unterzeichnerdesc: 'unterzeichner,desc',
    unterzeichnung: 'unterzeichnung',
    unterzeichnungasc: 'unterzeichnung,asc',
    unterzeichnungdesc: 'unterzeichnung,desc',
    inkrafttreten: 'inkrafttreten',
    inkrafttretenasc: 'inkrafttreten,asc',
    inkrafttretendesc: 'inkrafttreten,desc'
} as const;
export type GetVertragsdokumenteSort = typeof GetVertragsdokumenteSort[keyof typeof GetVertragsdokumenteSort];
